module.exports = __webpack_public_path__ + "img/nacActive.f0b1300c.png";